<script>
import APIStore from '@app/services/API/Store';

export default {
  data() {
    return {
      products: [],
      isFetching: false,
      isLoading: false,
      formData: {
        type: 'students',
        training_uuids: [],
        include_deleted: false,
        include_removed: false,
      },
    };
  },

  created() {
    this.fetchProducts();
  },

  computed: {
    canExportAbandonedCart() {
      return (
        this.$store.getters['auth/isNotPercentPlan']
      );
    },
    trainings() {
      const { list } = this.$store.state.trainings;
      return list ? list.data : null;
    },
    trainingOptions() {
      if (!this.trainings) return [];
      return this.trainings.map((curr) => ({
        label: curr.name,
        value: curr.uuid,
        disabled: curr.status === 'DRAFT',
        status: curr.status,
      }));
    },
  },

  methods: {
    async submit() {
      this.isLoading = true;

      if (this.formData.type === 'students') {
        await this.exportStudentsCSV();
      }

      if (this.formData.type === 'abandoned-cart') {
        await this.exportAbandonedCartCSV();
      }

      this.isLoading = false;
      return null;
    },

    exportAbandonedCartCSV() {
      return APIStore.exportAbandonedCart(this.$store.getters['auth/store'].uuid)
        .then(() => this.$buefy.dialog.alert(`
          Un export CSV listant TOUS vos paniers abandonnés
          vous sera envoyé par email.
          <strong>Attention : le traitement peut prendre plusieurs minutes !</strong>
        `))
        .finally(() => this.$emit('done'));
    },

    exportStudentsCSV() {
      const params = {
        training_uuids: this.formData.training_uuids,
        include_deleted: this.formData.include_deleted,
        include_removed: this.formData.include_removed,
      };

      return APIStore.exportCustomers(this.$store.getters['auth/store'].uuid, params)
        .then(() => this.$buefy.dialog.alert(`
          Un export CSV listant TOUS vos apprenants
          vous sera envoyé par email.
          <strong>Attention : le traitement peut prendre plusieurs minutes !</strong>
        `))
        .finally(() => this.$emit('done'));
    },

    fetchProducts() {
      this.isFetching = true;
      this.$store.dispatch('trainings/fetch')
        .finally(() => {
          this.isFetching = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <h1 class="title is-4">
      Export CSV <AppFeatureBadge v-if="formData.type === 'abandoned-cart'"
                                  class="ml-3"
                                  position="is-bottom" />
    </h1>
    <p v-if="formData.type === 'students'" class="mb-3">
      Obtenez un export de vos apprenants et des informations liées à leur assiduité
      (résultats aux quiz, temps passé sur les formations, etc).
    </p>
    <p v-else class="mb-3">
      Obtenez un export des personnes qui n'ont pas finalisé leur inscription
      à l'une de vos formations : ce sont les <strong>paniers abandonnés</strong>.
    </p>

    <template>
      <p v-if="formData.type === 'students'" class="notification is-info">
        La liste des apprenants comprend les apprenants actifs mais également ceux dont le statut
        est "bloqué".
      </p>
      <p v-else class="notification is-info">
        Rentrez en contact avec vos paniers abandonnés <strong>pour savoir ce qui les a empêché
        de finaliser leur inscription</strong>.
      </p>

      <go-pro-wrapper v-if="formData.type === 'abandoned-cart'" planLock="PRO" class="mb-3" />

      <form @submit.prevent="submit">
        <b-field label="Données à exporter">
          <b-select v-model="formData.type" required expanded>
            <option value="students">
              Liste des apprenants
            </option>
            <option value="abandoned-cart">
              Liste des paniers abandonnés
            </option>
          </b-select>
        </b-field>

        <template v-if="formData.type === 'students'">
          <b-field label="Filtrer par formation" :message="isFetching ? 'Chargement des formations...' : ''">
             <BaseMultipleSelect
               v-model="formData.training_uuids"
               label="Choisissez une ou plusieurs formations..."
             >
               <BaseMultipleSelectOption
                 v-for="option in trainingOptions"
                 :key="option.value"
                 :value="option.value"
                 :disabled="option.disabled"
               >
                 {{ option.label }}
               </BaseMultipleSelectOption>
             </BaseMultipleSelect>
          </b-field>

          <div class="field">
            <b-checkbox v-model="formData.include_deleted">
              Inclure les apprenants ayant supprimé leur compte
            </b-checkbox>
          </div>
          <div class="field">
            <b-checkbox v-model="formData.include_removed">
              Inclure les apprenants retirés de la formation
            </b-checkbox>
          </div>
        </template>

        <div class="buttons is-right">
          <b-button type="is-primary" native-type="submit" :loading="isLoading"
            :disabled="formData.type === 'abandoned-cart' && !canExportAbandonedCart">
            Exporter
          </b-button>
        </div>
      </form>
    </template>
  </div>
</template>
